import moment from "moment";
import {
  Calendar,
  Callout,
  Checkbox,
  DayOfWeek,
  DefaultButton,
  DirectionalHint,
  Dropdown,
  FocusTrapZone,
  IBasePickerSuggestionsProps,
  IDropdownOption,
  ITag,
  Spinner,
  SpinnerSize,
  Stack,
  TagPicker,
  Text,
} from "office-ui-fabric-react";
import React from "react";
import { useHistory } from "react-router";
import { getMomStatusCount } from "../../services/dashboard/DashboardService";
import { Loading } from "../../services/Loading";
import { IAdmin, IMomStatusCount } from "../../vm";
import { childrenGap, DayPickerStrings } from "../common/Constants";
import { ToastContext } from "../common/ToastProvider";
import ReportStatusCard from "./ReportStatusCard";
import { getAllAdmins } from "../../services/datacenter/DataCenterManagerService";
import { parseJwt } from "../../services/UtilService";

export interface MomStatusDashboardProps {
  cemUsers: IDropdownOption[]
}
let calendarButtonElement: HTMLElement;
const wrapperStyles = {
  // width: "100%",
  // maxWidth: 980,
  margin: "0 auto",
};

const MomStatusDashboard: React.FC<MomStatusDashboardProps> = ({ cemUsers }) => {
  // custom hooks
  const { showToast } = React.useContext(ToastContext);
  const history = useHistory();
  const tokenData = parseJwt();

  // const date = new Date();
  // // date.setMonth(date.getMonth() - 1);
  // const dateString = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
  // console.log("datestring", dateString);

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    momStatus: [],
    searchObj: {
      startDate: moment().startOf("month").toDate(),
      endDate: moment().endOf("month").toDate(),
      // startDate: moment().subtract(1, "month").startOf("month").toDate(),
      // endDate: moment().subtract(1, "month").endOf("month").toDate(),
      cemIds: tokenData.role === 2 ? [tokenData._id] : ['all'],
      ignoreDateRange: true
    },
    date: moment().toDate(),
    // date: moment().subtract(1, "month").toDate(),
    showCallender: false,
  } as {
    isLoading: boolean;
    momStatus: IMomStatusCount[];
    searchObj: {
      startDate: Date | string;
      endDate: Date | string;
      cemIds: string[];
      ignoreDateRange: boolean;
    };
    date: Date;
    showCallender: boolean;
  });
  const [cemUserList, setCemUserList] = React.useState([...cemUsers] as IDropdownOption[]);
  // const [cemUserList, setCemUserList] = React.useState([] as ITag[]);

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      setState({ ...state, isLoading: true });
      // await getAllCemUsers();
      await getMomStatus();
    };
    asyncFunc();
  }, []);

  const getMomStatus = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...paramState };
      setState({ ...localState, isLoading: true });
    }
    let searchObj = { ...localState.searchObj };
    searchObj.startDate = moment(searchObj.startDate).format("YYYY-MM-DD");
    searchObj.endDate = moment(searchObj.endDate).format("YYYY-MM-DD");

    let result = await getMomStatusCount({ ...searchObj, cemIds: searchObj.cemIds.includes('all') ? [] : searchObj.cemIds });
    if (result?.success) {
      let momStatus: IMomStatusCount[] = [];
      let totalCount = 0;
      // ["pending", "wip", "closed", "total"].forEach((ele) => {
      // ["open", "wip", "closed", "total"].forEach((ele) => {
      ["open", "under-observation", "wip", "closed", "total", "totalMOM"].forEach((ele) => {
        //   if (ele < 0) return;

        let item = result.data.find((c) => c._id === ele);
        if (item) {
          if (item._id !== "totalMOM") totalCount += item.count;
          momStatus.push(item);
        } else {
          momStatus.push({
            _id: ele,
            count: ele === "total" ? totalCount : 0,
            status: ele,
          });
        }
      });
      momStatus.push()
      console.log("momStatus", momStatus);
      setState({
        ...localState,
        momStatus,
      });
    } else {
      setState({ ...localState, isLoading: false });
      showToast(result?.message || "Error while getting mom status", "error");
    }
  };

  // const getAllCemUsers = async () => {
  //   let result = await getAllAdmins({ role: 2, sendEnabledItems: true });
  //   if (result && result.success) {
  //     let list: IDropdownOption[] = result.data.map((d: IAdmin) => ({ key: d._id, text: d.name }));
  //     setCemUserList(list);
  //   } else {
  //     showToast(result?.message || "Error while getting Cem users", "error");
  //   }
  // };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  // const cemPickerSuggestionsProps: IBasePickerSuggestionsProps = {
  //   noResultsFoundText: "No cem found",
  // };

  // const filterSuggestedTagsForCem = (filterText: string, tagList: ITag[]): ITag[] => {
  //   let allCemTags = [...cemUserList];

  //   return filterText
  //     ? allCemTags.filter(
  //       (tag) =>
  //         tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
  //         !listContainsTagList(tag, tagList)
  //     )
  //     : [];
  // };

  // const showAllTagsForCem = (selectedItems?: ITag[] | undefined) => {
  //   let allCemTags = [...cemUserList];

  //   return removeDuplicates(allCemTags, selectedItems);
  // };

  // function removeDuplicates(tagList: ITag[], tags?: ITag[]) {
  //   return tagList.filter((tag) => !listContainsTagList(tag, tags));
  // }

  // const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
  //   if (!tagList || !tagList.length || tagList.length === 0) {
  //     return false;
  //   }
  //   return tagList.some((compareTag) => compareTag.key === tag.key);
  // };

  const viewMomStatusDetails = (item: IMomStatusCount) => {
    if (item._id === "totalMOM") {
      history.push(
        `/customer-meetings?startDate=${moment(state.searchObj.startDate).format(
          "YYYY-MM-DD"
        )}&endDate=${moment(state.searchObj.endDate).format(
          "YYYY-MM-DD"
        )}&cemId=${state.searchObj.cemIds.length > 0 ? !state.searchObj.cemIds.includes('all') ? state.searchObj.cemIds[0] : "" : ""}&ignoreDateRange=${state.searchObj.ignoreDateRange}`
      );
    } else {
      history.push(
        `/mom-status-count?startDate=${moment(state.searchObj.startDate).format(
          "YYYY-MM-DD"
        )}&endDate=${moment(state.searchObj.endDate).format(
          "YYYY-MM-DD"
        )}&status=${item.status === 'total' ? '' : item.status}&cemId=${state.searchObj.cemIds.length > 0 ? !state.searchObj.cemIds.includes('all') ? state.searchObj.cemIds[0] : "" : ""}&ignoreDateRange=${state.searchObj.ignoreDateRange}`
      );
    }
  };

  return (
    <React.Fragment>
      {/* {state.isLoading && <Loading />} */}
      <div style={wrapperStyles}>
        <div className="ms-Grid p-0">
          <div className="ms-Grid-row ms-motion-scaleDownIn status-count-card overflow ml-0 mr-0">
            {state.isLoading && (
              <div className="custom-card spinner-center">
                <Spinner
                  size={SpinnerSize.large}
                // label="Loading"
                // labelPosition="bottom"
                />
              </div>
            )}
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12">
              <Stack horizontal horizontalAlign="space-between">
                <Stack.Item>
                  <Text className="dashboard-card-title">MOM</Text>
                </Stack.Item>
                <Stack.Item>
                  <Stack horizontal wrap tokens={childrenGap} verticalAlign="center" horizontalAlign="end">
                    <Stack.Item>
                      <Dropdown
                        selectedKey={state.searchObj.cemIds?.length > 0 ? state.searchObj.cemIds[0] : ""}
                        styles={{ dropdown: { width: 170 } }}
                        options={[{ key: 'all', text: 'All' }, ...cemUserList]}
                        onChange={async (e, v: IDropdownOption | undefined) => {
                          if (v) {
                            let obj = {
                              ...state,
                              searchObj: {
                                ...state.searchObj,
                                cemIds: [v.key as string]
                              },
                            };
                            await getMomStatus(obj as any);
                          }
                        }}
                      />
                      {/* <TagPicker
                        itemLimit={1}
                        selectedItems={cemUserList.filter((d) => state.searchObj.cemIds.includes(d.key as string))}
                        removeButtonAriaLabel="Remove"
                        onResolveSuggestions={filterSuggestedTagsForCem as any}
                        pickerSuggestionsProps={cemPickerSuggestionsProps}
                        onEmptyResolveSuggestions={showAllTagsForCem}
                        inputProps={{
                          placeholder: "Select a cem",
                        }}
                        styles={{ root: { minWidth: "200px" } }}
                        onChange={async (items: any) => {
                          let cemIds: string[] = [];
                          items.forEach((i: any) => {
                            cemIds.push(i.key);
                          });
                          let obj = {
                            ...state,
                            searchObj: {
                              ...state.searchObj,
                              cemIds
                            },
                          };
                          await getMomStatus(obj as any);
                        }}
                      /> */}
                    </Stack.Item>
                    <Stack.Item>
                      <div
                        ref={(calendarBtn) =>
                          (calendarButtonElement = calendarBtn!)
                        }
                      >
                        <DefaultButton
                          text={
                            !state.date
                              ? "Select a month"
                              : moment(state.date).format("MMM-YYYY")
                          }
                          onClick={() =>
                            setState({ ...state, showCallender: true })
                          }
                          className="month-picker-btn"
                          disabled={state.searchObj.ignoreDateRange}
                        />
                      </div>
                      {state.showCallender && (
                        <Callout
                          isBeakVisible={false}
                          // className="ms-DatePicker-callout"
                          gapSpace={0}
                          doNotLayer={false}
                          target={calendarButtonElement}
                          directionalHint={DirectionalHint.bottomLeftEdge}
                          onDismiss={() => closeCallender()}
                          setInitialFocus
                        >
                          <FocusTrapZone
                            firstFocusableSelector="ms-DatePicker-day--today"
                            isClickableOutsideFocusTrap
                          >
                            <Calendar
                              // eslint-disable-next-line react/jsx-no-bind
                              onSelectDate={async (
                                date: Date | null | undefined
                              ) => {
                                // setState()
                                let obj = {
                                  ...state,
                                  date: date as Date,
                                  searchObj: {
                                    ...state.searchObj,
                                    startDate: moment(date)
                                      .startOf("month")
                                      .toDate(),
                                    endDate: moment(date).endOf("month").toDate(),
                                  },
                                  showCallender: false,
                                };
                                await getMomStatus(obj);
                              }}
                              onDismiss={() => closeCallender()}
                              isMonthPickerVisible={true}
                              value={state.date}
                              firstDayOfWeek={DayOfWeek.Sunday}
                              strings={DayPickerStrings}
                              isDayPickerVisible={false}
                              highlightCurrentMonth={false}
                              highlightSelectedMonth={true}
                              showMonthPickerAsOverlay={false}
                              showGoToToday={false}
                              maxDate={new Date(Date.now())}
                            />
                          </FocusTrapZone>
                        </Callout>
                      )}
                    </Stack.Item>
                    <Stack.Item>
                      <Checkbox
                        label="Show All data irrespective of date"
                        checked={state.searchObj.ignoreDateRange}
                        onChange={async (e, v) => {
                          let obj = {
                            ...state,
                            searchObj: {
                              ...state.searchObj,
                              ignoreDateRange: v
                            },
                          };
                          await getMomStatus(obj as any);
                        }}
                      />
                    </Stack.Item>
                  </Stack>
                </Stack.Item>
              </Stack>
              <hr />
              <div className="ms-Grid-row">
                <div className="ms-Grid-col pt-0 ms-sm12 ms-md12 ms-lg12">
                  <div className="ms-Grid-row">
                    {state.momStatus.map((item, index) => (
                      <div
                        // className={`ms-Grid-col ms-sm12 ms-md12 ${index === state.momStatus.length - 1 ? "ms-lg12 ms-xl12" : "ms-lg6 ms-xl6"}`}
                        className={`ms-Grid-col ms-sm12 ms-md12 ms-lg6 ms-xl6`}
                        key={index}
                      >
                        <div
                          onClick={() =>
                            viewMomStatusDetails(item)
                            // index === 3 ? undefined : viewMomStatusDetails(item)
                          }
                        //   className={`${index === 3 ? "" : "pointer"}`}
                        >
                          <ReportStatusCard
                            status={item.status}
                            count={item.count}
                            isReportStatus={false}
                            isMomStatus={true}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MomStatusDashboard;
